import type en from '../en/profile'
import type { Translation } from '../types'

/** My profile: language, contact, password and the person’s own settings */
const profile: Translation<typeof en> = {
  "profile.language": "Taal",
  "profile.languageHint": "De taal van het dashboard en van de berichten die u ontvangt. ‘Gelijk aan het bedrijf’ volgt de taal van uw bedrijf.",
  "profile.sameAsCompany": "Gelijk aan het bedrijf",
  "profile.languageSaved": "Taal opgeslagen",
  "profile.languageNotSaved": "Kon de taal niet opslaan",
  "profile.pwChanged": "Wachtwoord gewijzigd",
  "profile.pwChangedText": "Alle sessies zijn uitgelogd; deze browser is opnieuw ingelogd.",
  "profile.pwFailed": "Het wachtwoord kon niet worden gewijzigd",
  "profile.pwCheck": "Controleer uw huidige wachtwoord en probeer het opnieuw.",
  "profile.vpnDownloaded": "VPN-bestand gedownload",
  "profile.vpnDownloadedText": "Importeer het .ovpn-bestand in uw OpenVPN-client.",
  "profile.downloadFailed": "Downloaden mislukt",
  "profile.vpnNotYet": "Het VPN-bestand is nog niet beschikbaar.",
  "profile.title": "Mijn profiel",
  "profile.alertContact": "Contact voor meldingen",
  "profile.alertContactText": "Voeg een telefoonnummer in internationale notatie toe om storingsmeldingen via WhatsApp of RCS te ontvangen.",
  "profile.appearance": "Weergave",
  "profile.theme.light": "Licht",
  "profile.theme.dark": "Donker",
  "profile.default": "(standaard)",
  "profile.account": "Account",
  "profile.companyAdmin": "Beheerder van het bedrijf",
  "profile.teamMember": "Teamlid",
  "profile.permissions": { one: "{count} recht", other: "{count} rechten" },
  "profile.vpnAccess": "VPN-toegang",
  "profile.lastSeen": "Laatst gezien",
  "profile.downloadVpn": ".ovpn-bestand downloaden",
  "profile.vpnCreating": "Uw VPN-account wordt aangemaakt. Dit duurt meestal enkele minuten.",
  "profile.noVpn": "Nog geen VPN-account.",
  "profile.setup": "Instructies",
  "profile.changePw": "Wachtwoord wijzigen",
  "profile.currentPw": "Huidig wachtwoord",
  "profile.hidePw": "Wachtwoord verbergen",
  "profile.showPw": "Wachtwoord tonen",
  "profile.newPw": "Nieuw wachtwoord",
  "profile.confirmPw": "Wachtwoord bevestigen",
  "profile.updatePw": "Wachtwoord bijwerken",
  "profile.phoneSaved": "Telefoonnummer opgeslagen",
  "profile.phoneSaveFailed": "Het nummer kon niet worden opgeslagen",
  "profile.codeSent": "Code verstuurd",
  "profile.codeSentRcs": "Kijk in de berichtenapp op die telefoon (RCS).",
  "profile.codeSentWa": "Kijk in WhatsApp op dat nummer.",
  "profile.codeFailed": "Er kon geen code worden verstuurd",
  "profile.phoneVerified": "Telefoonnummer geverifieerd",
  "profile.verifyFailed": "Verificatie mislukt",
  "profile.phone": "Telefoonnummer",
  "profile.verified": "geverifieerd",
  "profile.notVerified": "niet geverifieerd",
  "profile.save": "Opslaan",
  "profile.sendAgain": "Opnieuw versturen",
  "profile.sendCode": "Verificatiecode versturen",
  "profile.code": "Verificatiecode",
  "profile.codePlaceholder": "Code van 6 cijfers",
  "profile.verify": "Verifiëren",
  "profile.verifiedOnly": "WhatsApp- en RCS-meldingen worden alleen naar een geverifieerd nummer verstuurd.",
  "profile.phoneApp": "Telefoon-app",
  "profile.phoneAppAddress": "Kies in de Velanox-app „Aanmelden bij uw eigen bedrijf” en scan deze code, of typ het adres:",
  "profile.phoneAppSoon": "De app komt naar de App Store en Google Play.",
  "profile.phones": "Telefoons die aangemeld blijven",
  "profile.noPhones": "Geen telefoon blijft aangemeld.",
  "profile.thisPhone": "Deze telefoon",
  "profile.phoneAdded": "toegevoegd {when}",
  "profile.phoneUsed": "laatst gebruikt {when}",
  "profile.removePhoneOf": "{name} verwijderen",
  "profile.removePhoneConfirm": "{name} verwijderen? Die wordt afgemeld en vraagt opnieuw om het wachtwoord.",
  "profile.phoneRemoved": "Telefoon verwijderd",
  "profile.phoneRemoveFailed": "De telefoon is niet verwijderd",
  "profile.push.on": "Push: aan",
  "profile.push.off": "Push: uit",
  "profile.push.allow": "Pushmeldingen toestaan op deze telefoon",
  "profile.push.turnOff": "Pushmeldingen uitzetten",
  "profile.push.denied": "Pushmeldingen staan uit in de instellingen van deze telefoon",
  "profile.push.refused": "Pushmeldingen zijn niet toegestaan op deze telefoon",
  "profile.push.shortages": "Materiaaltekorten als pushmelding",
  "profile.push.shortagesHint": "Alleen uw telefoons: de e-mail over tekorten blijft zoals hij is.",
  "profile.push.notSaved": "De pushinstelling kon niet worden opgeslagen",
  "profile.push.channel": "Meldingen",
}

export default profile
